import { ADMIN_ROLES } from "@teamprevent/common/auth/roles";

export const routes = {
    "/allTasks": {
        title: "All Task Table",
        authorize: [ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name],
    }
};
